interface StatusTagProps {
  value?: string;
}

const STATUS_STYLES: Record<string, { className: string; label?: string }> = {
  active: { className: 'bg-success-500', label: 'Active' },
  inactive: { className: 'bg-error-500', label: 'Inactive' },
  locked: { className: 'bg-warning-500', label: 'Locked' },
  invited: { className: 'bg-primary-500', label: 'Invited' },
  published: { className: 'bg-primary-500', label: 'Published' },
  ongoing: { className: 'bg-warning-500', label: 'Ongoing' },
  completed: { className: 'bg-success-500', label: 'Completed' },
  cancelled: { className: 'bg-neutral-400', label: 'Cancelled' },
  draft: { className: 'bg-neutral-400', label: 'Draft' },
  sent: { className: 'bg-primary-500', label: 'Sent' },
  accepted: { className: 'bg-success-500', label: 'Accepted' },
  declined: { className: 'bg-error-500', label: 'Declined' },
  submitted: { className: 'bg-warning-500', label: 'Submitted' },
  confirmed: { className: 'bg-success-500', label: 'Confirmed' },
  rejected: { className: 'bg-error-500', label: 'Rejected' },
  expired: { className: 'bg-warning-500', label: 'Expired' },
  pending: { className: 'bg-warning-500', label: 'Pending' },
  'in progress': { className: 'bg-brand-500', label: 'In Progress' },
  upcoming: { className: 'bg-warning-500', label: 'Upcoming' },
  going: { className: 'bg-success-500', label: 'Going' },
  maybe: { className: 'bg-warning-500', label: 'Maybe' },
  not_going: { className: 'bg-error-500', label: 'Not Going' },
};

const StatusTag = ({ value }: StatusTagProps) => {
  const normalized = (value ?? '').toString().trim().toLowerCase();
  const config = STATUS_STYLES[normalized];

  // If no config found, use default
  const dotClassName = config?.className || 'bg-neutral-400';
  const label = config?.label || value || '-';

  return (
    <span className="inline-flex items-center gap-1.5 px-2 py-0.5 bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-full">
      <span className={`w-1.5 h-1.5 rounded-full ${dotClassName}`} />
      <span className="text-xs text-neutral-600 dark:text-neutral-400">
        {label}
      </span>
    </span>
  );
};

export default StatusTag;
